import React, { useEffect } from 'react';
import { CredentialData } from '@/common/types';
import { useBadgeMultiSelect } from '@/portal/hooks/useBadgeMultiSelect.ts';
import BadgeMultiSelect from '@/portal/components/BadgeMultiSelect.tsx';
import { loadCredentials } from '@/common/api/Credentials.ts';

interface CredentialMultiSelectProps {
  selected: CredentialData[];
  onChange: (updated: CredentialData[]) => void;
}

const CredentialMultiSelect: React.FC<CredentialMultiSelectProps> = ({
  selected,
  onChange,
}) => {
  const { allItems, selectedItems, toggleItem } =
    useBadgeMultiSelect<CredentialData>({
      loadAllItems: loadCredentials,
      initialSelected: selected,
    });

  useEffect(() => {
    onChange(selectedItems);
  }, [selectedItems, onChange]);

  return (
    <BadgeMultiSelect
      label="Credentials"
      allItems={allItems}
      selectedItems={selectedItems}
      onToggle={toggleItem}
      getId={(badge) => badge.id}
      getLabel={(badge) => badge.title}
    />
  );
};

export default CredentialMultiSelect;
